import {Component, HostBinding, HostListener, Injectable, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {MedicalEducationService} from '../../domain/model/education/medical/medical-education.service';
import {CompletedInUSAProjection} from '../../domain/model/education/medical/medical-education.projections';
import {BoardAffiliationInformation} from '../../domain/model/licenses-certifications/board/information/board-affiliation-information.model';
import {BoardAffiliationInformationService} from '../../domain/model/licenses-certifications/board/information/board-affiliation-information.service';
import {WorkService} from '../../domain/model/work/history/work.service';
import {Roles} from '../../domain/authorization/roles';

//region Other Classes
const Sections = {
    EDUCATION: 'education',
    WORK: 'work'
};
//endregion

@Component({
    selector: 'my-left-navigation',
    template: require('./left-nav.component.html'),
    styles: [require('./left-nav.component.scss')]
})
@Injectable()
export class LeftNavComponent implements OnInit {

    private _showMenu: boolean = false;

    medicalEducationCompletedInUSA?: boolean;
    showWorkObservationsScreen?: boolean;
    boardAffiliationInformation?: BoardAffiliationInformation;

    Roles = Roles;

    constructor(private _router: Router,
                private readonly _educationService: MedicalEducationService,
                private readonly _workService: WorkService,
                private readonly _boardAffiliationInformationService: BoardAffiliationInformationService) {

        _boardAffiliationInformationService.changes$.startWith(true)
            .switchMap(() => _boardAffiliationInformationService.getCurrentUserModel())
            .subscribe(it => this.boardAffiliationInformation = it);
    }

    @HostBinding('class.show-drawer') _showDrawer: boolean = false;

    @HostListener('document:click', ['$event'])
    docClicked(event: MouseEvent) {
        let elem = $(event.target);
        let isMenuClick = elem.hasClass('sliding-menu')
            || elem.closest('.sliding-menu').length
            || elem.hasClass('side-menu')
            || elem.closest('.side-menu').length;
        if (!isMenuClick) {
            this._showMenu = false;
        }
    }

    ngOnInit() {
    }

    menuClick(event, section: string) {
        this._refreshSectionsInformation(section).subscribe(() => {
            let $element = event.target.tagName.toLowerCase() === 'a' ? $(event.target) : $(event.target).closest('a');
            if ($element.hasClass('active')) {
                this._showMenu = !this._showMenu;
            } else {
                let navCommands = this._sectionNavigationCommands(section) || ['/', section];
                this._router.navigate(navCommands);
                this._showMenu = false;
                this._showDrawer = false;
            }
        });
    }

    hideSubmenu() {
        this._showMenu = false;
        this._showDrawer = false;
    }

    toggleDrawer() {
        this._showDrawer = !this._showDrawer;
    }

    closeDrawer() {
        this._showMenu = false;
        this._showDrawer = false;
    }

    isActive(instruction: string): boolean {
        return this._router.isActive(instruction, false);
    }

    /** Readonly properties. */
    get visibleMenu() {
        return this._showMenu;
    }

    private _sectionNavigationCommands(section: String): any[]|undefined {
        if (section === Sections.EDUCATION && this.medicalEducationCompletedInUSA !== undefined) {
            return ['/', 'education', this.medicalEducationCompletedInUSA ? 'premedical' : 'ecfmg'];
        }
    }

    private _refreshSectionsInformation(section: string): Observable<boolean> {
        //TODO "monkey-patch" for this navigation component
        //ideally the information should be retrieved/observed from SectionsService

        if (section === Sections.EDUCATION) {
            return this._educationService.getCurrentUserModel(CompletedInUSAProjection)
                .do(value => this.medicalEducationCompletedInUSA = value ? value.completedInUSA : undefined)
                .map(() => true);
        }
        else if (section === Sections.WORK) {
            return this._workService.doHistoryGapsExist()
                .do(value => this.showWorkObservationsScreen = value)
                .map(() => true);
        }
        else {
            return Observable.of(true);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/navigation/left/left-nav.component.ts